import { ChangeDetectorRef, Component, HostListener, Injector, ViewChild, ViewEncapsulation } from "@angular/core";
import { FormlyFormBuilder } from "@ngx-formly/core";
import { ConfirmationService, TreeNode } from "primeng/api";
import { environment } from "../../../../environments/environment";
import { DetailedCreatedSendProductReportViewComponent } from "../../../shared/component/detailed-view/detailed-create-send-product-report/detailed-create-send-product-report-view.component";
import { TreeViewComponent } from "../../../shared/component/tree-view/tree-view.component";
import { AuthService } from "../../../shared/service/auth-service/auth-service.service";
import { ExportServiceComponent } from "../../../shared/service/export-service/export.service";
import { XevprmSubmissionService } from "../../../shared/service/xevprm-submission-service/xevprm-submission.service";
import { Art57Section } from "../../../shared/ui/Art57Section/Art57Section";
import { ButtonParam } from "../../../shared/ui/ButtonParam";
import { ListView } from "../../../shared/ui/Data/ListView";
import { Art57Node } from "../../../shared/ui/Node/Art57Node/Art57Node";
import { Art57NodeUtils } from "../../../shared/ui/Node/Art57Node/Art57NodeUtils";
import { TreeNodeDrugIngredient } from "../../../shared/ui/Node/Art57Node/Entity/TreeNodeDrugIngredient";
import { TreeNodeATCCodeList } from "../../../shared/ui/Node/Art57Node/ListEntity/TreeNodeATCCodeList";
import { TreeNodeAttachmentList } from "../../../shared/ui/Node/Art57Node/ListEntity/TreeNodeAttachmentList";
import { TreeNodeDrugIngredientsList } from "../../../shared/ui/Node/Art57Node/ListEntity/TreeNodeDrugIngredientsList";
import { TreeNodeMasterFileLocationList } from "../../../shared/ui/Node/Art57Node/ListEntity/TreeNodeMasterFileLocationList";
import { TreeNodeOrganisationList } from "../../../shared/ui/Node/Art57Node/ListEntity/TreeNodeOrganisationList";
import { TreeNodePharmaceuticalFormList } from "../../../shared/ui/Node/Art57Node/ListEntity/TreeNodePharmaceuticalFormList";
import { TreeNodeProductsList } from "../../../shared/ui/Node/Art57Node/ListEntity/TreeNodeProductsList";
import { TreeNodeRoutesOfAdministrationList } from "../../../shared/ui/Node/Art57Node/ListEntity/TreeNodeRoutesOfAdministrationList";
import { TreeNodeSourceList } from "../../../shared/ui/Node/Art57Node/ListEntity/TreeNodeSourceList";
import { TreeNodeSubstancesList } from "../../../shared/ui/Node/Art57Node/ListEntity/TreeNodeSubstancesList";
import { ErrorControlUtil } from "../../../shared/ui/ErrorControlUtil";
import { BaseNode } from "../../../shared/ui/Node/BaseNode";
import { SectionService } from "../../../shared/service/section-service/section-service";
import { LoggerService } from "../../../shared/service/logger-service/logger.service";
import { testingEnum } from "../../../shared/common/enum/testingEnum";
import { MINIMUM_TREE_WITDH } from "../../../shared/ui/Constants";

@Component({
  selector: 'app-create-send-product-report',
  templateUrl: './create-send-product-report-component.html',
  styleUrl: './create-send-product-report-component.scss',
  encapsulation: ViewEncapsulation.None
})
export class CreateSendProductReportComponent {
  @ViewChild('tree_view_component') tree_view_component!: TreeViewComponent;
  @ViewChild('detail_view_component') detail_view_component!: DetailedCreatedSendProductReportViewComponent;
  nodes: Art57Node[] = [];
  selectedNode: Art57Node | undefined;
  initialized: boolean = false;

  constructor(
    public authService: AuthService,
    private submissionService: XevprmSubmissionService,
    private exportService: ExportServiceComponent,
    private formlyBuilder: FormlyFormBuilder,
    public sectionService: SectionService,
    private cdr: ChangeDetectorRef,
    private confirmationService: ConfirmationService,
    public injector: Injector,
    private loggerService: LoggerService) {
  }

  confirmValidateErrors() {
    const firstError: any = this.injector.get(Art57Section).productReports.getFieldsErrorsControl().getFirstError();
    const errorNodeLabel: string = firstError.node.labelNodeName;
    this.confirmationService.confirm({
      header: 'Validation',
      message: '<strong>Validate Failed</strong><br><span>' + this.injector.get(Art57Section).productReports.getFieldsErrorsControl().getTotalErrorsFound() + ' Error(s) present.</span><br><br><strong>First error(s):</strong><br><span>' +
        errorNodeLabel + (firstError.controlLabel ? '/' + firstError.controlLabel : '') + '</span><br><br><span>' + firstError.error + '</span><br><br>',
      icon: 'pi pi-question-circle',
      acceptLabel: 'Go to first error',
      rejectLabel: 'Close',
      accept: () => {
        this.injector.get(Art57Section).productReports.getFieldsErrorsControl().setErrorsPositionToFistError();
        this.gotoErrorNode(firstError.node, firstError.controlId);
      },
      reject: () => {
        // do nothing
      }
    });
  }

  private removeNode(nodeToRemove: BaseNode) {

    const parentNode: TreeNode = nodeToRemove.parent!;
    parentNode!.children!.splice(parentNode!.children!.indexOf(nodeToRemove), 1);
    this.injector.get(Art57Section).productReports.getFieldsErrorsControl().removeNodeErrors(nodeToRemove);
    (parentNode as BaseNode).refreshLabel();

    this.injector.get(Art57Section).productReports.getFieldsErrorsControl().removeNodeErrors(nodeToRemove);
  }

  onRemoveNode(nodeToRemove: any) {
    this.confirmationService.confirm({

      header: 'Remove',
      message: 'Are you sure You want to remove the selected Item?',
      icon: 'pi pi-question-circle',
      acceptLabel: 'OK',
      rejectLabel: 'Cancel',
      accept: () => {
        if (nodeToRemove && nodeToRemove.parent) {

          this.removeNode(nodeToRemove);
          this.injector.get(Art57Section).showTooltipMessage({ severity: 'success', detail: 'Item has been removed', life: environment.successElapsedTime });

          if ((!(nodeToRemove.data instanceof ListView)) && (!(this.selectedNode instanceof TreeNodeDrugIngredientsList))) {
            this.onSelectedNodeChange(nodeToRemove.parent as Art57Node);
          }
        }
      },
      reject: () => {
        // do nothing
      }
    });
  }

  onRemoveSelectedNodes(nodeList: any) {
    if ((nodeList.children.filter((element: any) => element.checked)).length > 0) {
      this.confirmationService.confirm({

        header: 'Remove',
        message: 'Are you sure you want to remove all selected Items?',
        icon: 'pi pi-question-circle',
        acceptLabel: 'OK',
        rejectLabel: 'Cancel',
        accept: () => {
          if (nodeList) {
            nodeList.children.filter((element: any) => element.checked).forEach((nodeToRemove: BaseNode) => {
              this.removeNode(nodeToRemove);
            });
          }
          this.injector.get(Art57Section).showTooltipMessage({ severity: 'success', detail: 'Items have been removed', life: environment.successElapsedTime });
        },
        reject: () => {
          // do nothing
        }
      });
    }
  }

  onResetApplication() {
    this.injector.get(Art57Section).resetApplication().then(applicationReseted => {
      if (applicationReseted) {
        this.initializeSection();
      }
    });
  }


  onResetSection() {
    this.injector.get(Art57Section).resetSection(this.injector.get(Art57Section).productReports).then(sectionReseted => {
      if (sectionReseted) {
        this.initializeSection();
      }
    });
  }

  leftColumnWidth: number = this.injector.get(Art57Section).tree_width;
  rightColumnWidth: number = window.innerWidth - this.leftColumnWidth;

  onResize(clientX: number): void {

    const container = document.querySelector('#main-container') as HTMLElement;

    if (container) {
      const containerRect = container.getBoundingClientRect();
      this.injector.get(Art57Section).tree_width = clientX - containerRect.left;
      const minWidth = MINIMUM_TREE_WITDH;
      const maxWidth = containerRect.width - 100;
      this.leftColumnWidth = Math.max(minWidth, Math.min(this.injector.get(Art57Section).tree_width, maxWidth));
    }
  }

  isResizing: boolean = false;
  onResizing(isResizing: boolean) {
    this.isResizing = isResizing;
  }


  //Selection node event
  onNodeSelect(event: any) {
    this.selectedNode = event.node;
    if (this.selectedNode) {
      this.injector.get(Art57Section).productReports.selectedNode = this.selectedNode;
    }
    this.selectedNode!.children?.forEach((c: TreeNode) => (c as Art57Node).refreshLabel(false));
  }

  onGoToSelectedNode(selectedNode: BaseNode) {
    this.onNodeSelect({ node: selectedNode });
    this.moveTreeViewToNode(this.selectedNode as TreeNode);
    this.onValidate();
    this.expandParentNodes(selectedNode);
  }

  //Model changed
  onModelChange(model: any) {

    if (this.selectedNode) {

      if (this.selectedNode instanceof Art57Node) {
        this.selectedNode.refreshLabel();
        this.onValidateNode(this.selectedNode); // force repaint on p-tree node (red or normal color depending of validity of the node)
      }

    }

  }

  onExport(type: string) {

    this.injector.get(Art57Section).showTooltipMessage({ severity: 'success', detail: 'Message is being exported...', life: environment.successElapsedTime });

    this.exportService.get(type, this.nodes[0].getMessage()).subscribe({
      next: (response) => {
        const blob = new Blob([response], { type: 'application/' + type });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        let messagenumb = (this.nodes[0].getMessage() && this.nodes[0].getMessage().ichicsrmessageheader && this.nodes[0].getMessage().ichicsrmessageheader.messagenumb) ? this.nodes[0].getMessage().ichicsrmessageheader.messagenumb : 'NN';
        a.href = url;

        if (type != 'rtf') {
          a.download = this.authService.getUser() + '@' + new String(this.authService.getOrganisation()).toLowerCase() + '-Export-' + this.authService.getOrganisation() + '-XEVPRM-' + messagenumb + '-' + this.getDate() + '-01' + '.' + type;
        } else {
          a.download = this.authService.getUser() + '@' + new String(this.authService.getOrganisation()).toLowerCase() + '-RTF-NS-NT-' + messagenumb + '-' + this.getDate() + '-01' + '.' + type;
        }
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        this.injector.get(Art57Section).showTooltipMessage({ severity: 'success', detail: 'Message has been exported successfully', life: environment.successElapsedTime });

      },
      error: (error) => {
        this.injector.get(Art57Section).showTooltipMessage({ severity: 'error', detail: 'Error exporting', life: environment.successElapsedTime });
        this.loggerService.err('Error exporting ' + type, error);
      }
    });
  }

  getDate(): string {
    const date = new Date();

    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const hour = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    return `${year}-${month}-${day}+${hour}.${minutes}.${seconds}`;
  }

  onAdd() {

    if (this.selectedNode) {
      this.selectedNode.createChildTemplate();
      this.onModelChange(undefined);
    }

  }

  onSend() {

    if (!this.existsErrors()) {

      const message = this.nodes[0].getMessage();
      const link = document.createElement('a');
      let url: string;
      this.submissionService.submit(message, message.attachments ? message.attachments.attachment : null).subscribe(response => {

        url = URL.createObjectURL(new Blob([response.file], { type: 'text/xml' }));

        link.href = url;
        link.download = response.filename + '.xml';

        this.injector.get(Art57Section).showTooltipMessage({ severity: 'success', detail: 'Message has been sent successfully', life: environment.successElapsedTime });

        this.confirmationService.confirm({
          header: 'Message sent successfully',
          message: "Click on the link below to review the XML message submitted.<br><br><a href='" + link.href + "' target='_blank'>" + link.download + "</a>" + "<br><br>During peak hours, the system may experience high workloads causing delays in displaying the submitted XEVPRM in<br/>your WebTrader outbox immediately. Please refresh your outbox after 10 minutes since submission to view the file. <br><br>The XML file of the XEVPRM Acknowledgement will be available in your WebTrader inbox within maximum 48 hours. <br>If this is not the case please contact us through <a href='" + environment.serviceDeskURL + "' target='_blank'>EMA Service Desk<a/>.",
          icon: 'pi pi-question-circle',
          acceptLabel: 'Download',
          rejectLabel: 'Close',
          accept: () => {
            link.click();
            URL.revokeObjectURL(url);
          },
          reject: () => {
            URL.revokeObjectURL(url);
          }
        });

      }, error => {
        this.injector.get(Art57Section).showTooltipMessage({ severity: 'error', detail: 'Error sending message', life: environment.errorElapsedTime });
        this.loggerService.err('Error sending message', error);
      });




      this.injector.get(Art57Section).showTooltipMessage({ severity: 'success', detail: 'Sending the message...', life: environment.successElapsedTime });

    }
  }

  getFieldsErrorsControl() {
    return this.injector.get(Art57Section).productReports.getFieldsErrorsControl();
  }

  manageButtonAdd(buttonParam: ButtonParam) {
    let node: TreeNode<any> | null;
    let newNode: Art57Node[] | null;

    switch (buttonParam.nodeTypeToCreateName) {
      case '':
        node = this.selectedNode!;
        break;
      case 'addAuthorisedProduct':
        node = Art57NodeUtils.findFirstChildNodeOfType(this.nodes[0], TreeNodeProductsList);
        break;
      case 'addDevelopmentProduct':
        node = Art57NodeUtils.findFirstChildNodeOfType(this.nodes[0], TreeNodeProductsList);
        break;
      case 'addAttachment':
        node = Art57NodeUtils.findFirstChildNodeOfType(this.nodes[0], TreeNodeAttachmentList);
        break;
      case 'addApprovedSubstance':
        node = Art57NodeUtils.findFirstChildNodeOfType(this.nodes[0], TreeNodeSubstancesList);
        break;
      case 'addDevelopmentSubstance':
        node = Art57NodeUtils.findFirstChildNodeOfType(this.nodes[0], TreeNodeSubstancesList);
        break;
      case 'addSource':
        node = Art57NodeUtils.findFirstChildNodeOfType(this.nodes[0], TreeNodeSourceList);
        break;
      case 'addOrganisation':
        node = Art57NodeUtils.findFirstChildNodeOfType(this.nodes[0], TreeNodeOrganisationList);
        break;
      case 'addATCCode':
        node = Art57NodeUtils.findFirstChildNodeOfType(this.nodes[0], TreeNodeATCCodeList);
        break;
      case 'addPharmaceuticalForms':
        node = Art57NodeUtils.findFirstChildNodeOfType(this.nodes[0], TreeNodePharmaceuticalFormList);
        break;
      case 'addRoutesOfAdministration':
        node = Art57NodeUtils.findFirstChildNodeOfType(this.nodes[0], TreeNodeRoutesOfAdministrationList);
        break;
      case 'addMasterFileLocations':
        node = Art57NodeUtils.findFirstChildNodeOfType(this.nodes[0], TreeNodeMasterFileLocationList);
        break;
    }

    if (node!) {
      newNode = (node as Art57Node).createChildTemplate(buttonParam);
      if (newNode!) {
        this.onNodeSelect({ node: newNode[0] });
      }
      this.moveTreeViewToNode(this.selectedNode as TreeNode);
    }

  }

  moveTreeViewToNode(node: TreeNode) {
    this.expandParentNodes(node);
    node!.expanded = true;
    if (!(node instanceof TreeNodeDrugIngredient)) {
      this.cdr.detectChanges(); // allow detection that component view is draw in browser so we can change the focus in the right view
    }
    this.setTreeViewScroll(node.key!);
  }

  onButtonAction(buttonAction: any) {
    switch (buttonAction.action) {
      case 'resetApplication':
        this.onResetApplication();
        break;
      case 'resetSection':
        this.onResetSection();
        break;
      case 'export':
        this.onExport(buttonAction.param);
        break;
      case 'duplicate':
        if (this.selectedNode && this.selectedNode.parent) {
          let node = this.selectedNode.cloneNode(this.selectedNode.parent as Art57Node);
          if (node){
            this.selectedNode.parent.children?.push(node);
            (this.selectedNode.parent as Art57Node).refreshLabel();
            this.onNodeSelect({ node: node });
            this.moveTreeViewToNode(node as TreeNode);
            this.onValidate();
          }
        }
        break;
      case 'remove':
        this.onRemoveNode(buttonAction.param);
        break;
      case 'removeall':
        this.onRemoveSelectedNodes(buttonAction.param);
        break;
      case 'add':
        this.manageButtonAdd(buttonAction.param);
        this.onValidate();
        break;
      case 'validate':
        this.injector.get(Art57Section).showTooltipMessage({ severity: 'success', detail: 'Validating', life: environment.successElapsedTime });
        setTimeout(() => {
          this.existsErrors();
        }, 0);
        break;
      case 'send':
        this.onSend();
        break;
      case 'nextError':
        this.onNextError();
        break;
      case 'previousError':
        this.onPreviousError();
        break;
      case 'selectAll':
        this.injector.get(Art57Section).changeSelectAll((buttonAction.param as Art57Node), true);
        break;
      case 'deselectAll':
        this.injector.get(Art57Section).changeSelectAll((buttonAction.param as Art57Node), false);
        break;
    }
  }

  showFieldsErrorsControlTooltips(errorNode: any) {

    this.injector.get(Art57Section).showTooltipMessage({ severity: 'warn', detail: this.injector.get(Art57Section).productReports.getFieldsErrorsControl().getTotalErrorsFound() + ' error(s) left', life: environment.warningElapsedTime });
    const erroNodeLabel: string = errorNode.node.labelNodeName;
    this.injector.get(Art57Section).showTooltipMessage({
      severity: 'error',
      summary:
        erroNodeLabel +
        (errorNode.controlLabel ? '/' + errorNode.controlLabel : ''),
      detail: errorNode.error,
      life: environment.errorElapsedTime
    });
  }
  onPreviousError() {
    this.onValidateNode(this.selectedNode);
    if (this.injector.get(Art57Section).productReports.getFieldsErrorsControl().existsErrors()) {
      const erroNode = this.injector.get(Art57Section).productReports.getFieldsErrorsControl().getPreviousError();
      this.gotoErrorNode(erroNode.node, erroNode.controlId);
      this.showFieldsErrorsControlTooltips(erroNode);
    } else {
      this.injector.get(Art57Section).showTooltipMessage({ severity: 'success', detail: 'No Errors', life: environment.successElapsedTime });
    }
  }

  onNextError() {
    this.onValidateNode(this.selectedNode);
    if (this.injector.get(Art57Section).productReports.getFieldsErrorsControl().existsErrors()) {
      const errorNode = this.injector.get(Art57Section).productReports.getFieldsErrorsControl().getNextError();
      this.gotoErrorNode(errorNode.node, errorNode.controlId);
      this.showFieldsErrorsControlTooltips(errorNode);
    } else {
      this.injector.get(Art57Section).showTooltipMessage({ severity: 'success', detail: 'No Errors', life: environment.successElapsedTime });
    }
  }

  initializeSection() {
    //Create TreeView template

    this.nodes = this.injector.get(Art57Section).productReports.treeView;

    //Set selected node
    this.onNodeSelect({ node: this.injector.get(Art57Section).productReports.selectedNode });

    //Validate message
    //this.onValidate();

  }

  //Initialize 
  ngOnInit() {
    this.initializeSection();
    this.sectionService.changeProductReportSelectedNode$.subscribe({ next: node => 
      {
        if (!node) {
          return;
        }

        if (!this.initialized) {
          this.initialized = true;
          return;
        }
        
        this.onGoToSelectedNode(node) 
      }  
    })
  }

  onSelectedNodeChange(selectedNode: BaseNode) {
    this.onNodeSelect({ node: selectedNode });
    this.onValidateNode(selectedNode);
    this.expandParentNodes(selectedNode);
  }

  expandParentNodes(node: TreeNode) {
    node.expanded = true;
    if (node.parent) {
      this.expandParentNodes(node.parent); // Recursively expand children
    }
  }

  // Function to validate all forms globally
  onValidate() {
    const errorsFound = ErrorControlUtil.findErrors(this.injector, this.nodes, this.formlyBuilder, this.selectedNode, true);
    this.injector.get(Art57Section).productReports.getFieldsErrorsControl().initializeErrors(errorsFound);
  }

  onValidateNode(selectedNode: any) {
    const errorsFound = ErrorControlUtil.findErrors(this.injector, [selectedNode], this.formlyBuilder, selectedNode);
    this.injector.get(Art57Section).productReports.getFieldsErrorsControl().updateErrors(errorsFound, selectedNode);
  }

  gotoErrorNode(node: TreeNode<any>, controlId: string) {
    this.expandParentNodes(node);
    this.onNodeSelect({ node: node });
    this.cdr.detectChanges(); // allow detection that component view is draw in browser so we can change the focus in the right view
    this.setFormlyFormField(controlId);
  }

  existsErrors(): boolean {
    this.injector.get(Art57Section).productReports.getFieldsErrorsControl().setValidateButtonPressed();
    this.onValidate();
    if (this.injector.get(Art57Section).productReports.getFieldsErrorsControl().existsErrors()) {
      this.confirmValidateErrors();
      return true;
    }
    this.injector.get(Art57Section).showTooltipMessage({ severity: 'success', id:testingEnum.ValidateOkToastMsg, detail: 'Validate OK', life: environment.successElapsedTime });
    return false;
  }


  setFormlyFormField(formlyFieldFocus: string) {

    if (formlyFieldFocus != '') {

      const formlyForm = (this.detail_view_component as any).formly_detailed_view_component;
      if (formlyForm) {
        formlyForm.setFocusOnFormlyField(formlyFieldFocus);
      }
    }
  }

  setTreeViewScroll(key: string) {
    if (key != '') {

      const treeView = this.tree_view_component;
      if (treeView) {
        treeView.setScrollAtSelectedElement(key);
      }
    }
  }

  isTreeContainerVisible: boolean = true;

  toggleTreeContainer(): void {
    this.isTreeContainerVisible = !this.isTreeContainerVisible;
  }

}
